import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import cancel from '../../images/common/close.svg';
import ColorSF2 from '../../styles/common/ColorSF2';

const Main = styled.div`
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: ${ColorSF2.paleBlue};
  padding: 0 10px;
  height: 50px;
  margin-bottom: 5px;
  @media (max-height: 530px) {
    height: 30px;
  }
`;
const style = {
  contents: {
    padding: 15,
    flex: '0 0 auto',
  },
  contentsTitle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
  },
  link: {
    color: '#3aa1e2',
    textDecoration: 'none',
    cursor: 'pointer',
  },
  closeImage: {
    width: 20,
    height: 20,
  },
  closeButton: {
    width: 20,
    height: 20,
  },
};

const TimeLineTileTitle = () => {
  const linkTo = '/ds/';
  return (
    <Main className="timeLineTitle">
      <div style={style.contents}>
        <div style={style.contentsTitle} />
      </div>
      <div
        className="button"
        id="clickCloseButton"
        role="presentation"
        style={style.closeButton}
      >
        <Link to={linkTo} style={style.link}>
          <img
            style={style.closeImage}
            src={cancel}
            alt="timelineOpenCloneButton"
          />
        </Link>
      </div>
    </Main>
  );
};

export default TimeLineTileTitle;
